import axios from 'axios'

const baseURL = process.env.REACT_APP_API

const defaultHeaders = {
  'X-Requested-With': 'XMLHttpRequest',
}

const getApiOrigin = () => {
  if (!baseURL) return ''

  try {
    return new URL(baseURL).origin
  } catch (error) {
    return ''
  }
}

const getCookieValue = (name) => {
  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const matched = document.cookie.match(
    new RegExp(`(?:^|; )${escapedName}=([^;]*)`)
  )

  return matched ? decodeURIComponent(matched[1]) : null
}

const csrfClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: defaultHeaders,
})

let csrfRequestPromise = null

const ensureCsrfCookie = async () => {
  if (csrfRequestPromise) {
    return csrfRequestPromise
  }

  const apiOrigin = getApiOrigin()
  const sanctumPath = apiOrigin ? `${apiOrigin}/sanctum/csrf-cookie` : '/sanctum/csrf-cookie'
  const legacyPath = apiOrigin ? `${apiOrigin}/csrf-cookie` : '/csrf-cookie'

  csrfRequestPromise = csrfClient
    .get(sanctumPath)
    .catch(() => csrfClient.get(legacyPath))
    .finally(() => {
      csrfRequestPromise = null
    })

  return csrfRequestPromise
}

const attachCsrfProtection = (client) => {
  client.interceptors.request.use(async (config) => {
    const method = (config?.method || 'get').toLowerCase()
    const isMutatingMethod = ['post', 'put', 'patch', 'delete'].includes(method)

    if (isMutatingMethod) {
      await ensureCsrfCookie()
      const xsrfToken = getCookieValue('XSRF-TOKEN')

      if (xsrfToken) {
        config.headers = config.headers || {}
        config.headers['X-XSRF-TOKEN'] = xsrfToken
      }
    }

    return config
  })
}

const axiosPublic = axios.create({
  baseURL,
  withCredentials: true,
  headers: defaultHeaders,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
})

export const axiosPrivate = axios.create({
  baseURL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    ...defaultHeaders,
  },
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
})

attachCsrfProtection(axiosPublic)
attachCsrfProtection(axiosPrivate)

export default axiosPublic
